import { createBrowserRouter, Navigate } from "react-router-dom";
import App from "../App";
import Inspection from "../pages/Inspection";
import { InspectionViewTypes } from "../types/InspectionViewType";
import { SecuredRoute } from "../Authentication/SecuredRoute";
import { VesselGallery } from "../components/vessel-info/vesselGallery";
import { ErrorPage } from "../pages/Error";
import Inspections from "../pages/Inspections";
import Quotations from "../pages/Quotations";
import { QuotationDetailsPage } from "../components/quotation-details/QuotationDetailsPage";
import Orders from "../pages/Orders";
import { QuotationCreatePage } from "../components/quotation-details/QuotationCreatePage";
import { Screening } from "../pages/Screening";

export const INSPECTIONS_ROUTE = "inspections";
export const REPORTS_ROUTE = "reports";
export const INSPECTION_ROUTE = "inspection";
export const QUOTATIONS_ROUTE = "quotations";
export const SCREENING_ROUTE = "screening";
export const ORDERS_ROUTE = "orders";
export const ERROR_ROUTE = "error";

export const createRouter = () =>
    createBrowserRouter([
        {
            path: "/",
            element: <App />,
            children: [
                {
                    path: "/",
                    element: <Navigate to="/inspections" replace={true} />
                },
                {
                    path: "/inspection/:inspectionId",
                    element: <SecuredRoute />,
                    children: [
                        {
                            path: "",
                            element: <Inspection />
                        },
                        {
                            path: "images",
                            element: <VesselGallery autoOpen={true} />
                        },
                        {
                            path: "summary",
                            element: (
                                <Inspection
                                    view={InspectionViewTypes.SUMMARY_TAB}
                                />
                            )
                        },
                        {
                            path: "particulars",
                            element: (
                                <Inspection
                                    view={InspectionViewTypes.PARTICULARS_TAB}
                                />
                            )
                        },
                        {
                            path: "notable-items",
                            element: (
                                <Inspection
                                    view={InspectionViewTypes.NOTABLE_ITEMS_TAB}
                                />
                            )
                        },
                        {
                            path: "grading",
                            element: <Inspection />
                        },
                        {
                            path: "documents",
                            element: (
                                <Inspection
                                    view={InspectionViewTypes.DOCUMENT_TAB}
                                />
                            )
                        },
                        {
                            path: "grade-comparison",
                            element: (
                                <Inspection
                                    view={
                                        InspectionViewTypes.GRADING_COMPARISON_TAB
                                    }
                                />
                            )
                        }
                    ]
                },
                {
                    path: "*",
                    element: <ErrorPage status={404} /> // Catch-all route for 404 errors
                },
                {
                    path: `/${INSPECTIONS_ROUTE}`,
                    element: <SecuredRoute />,
                    children: [
                        {
                            path: "",
                            element: <Inspections />
                        }
                    ]
                },
                {
                    path: `/${QUOTATIONS_ROUTE}`,
                    element: <SecuredRoute />,
                    children: [
                        {
                            path: "",
                            element: <Quotations />
                        }
                    ]
                },
                {
                    path: `/${QUOTATIONS_ROUTE}/:quotationId`,
                    element: <SecuredRoute />,
                    children: [
                        {
                            path: `/${QUOTATIONS_ROUTE}/:quotationId`,
                            element: <QuotationDetailsPage />
                        }
                    ]
                },
                {
                    path: `/${QUOTATIONS_ROUTE}/create`,
                    element: <SecuredRoute />,
                    children: [
                        {
                            path: `/${QUOTATIONS_ROUTE}/create`,
                            element: <QuotationCreatePage />
                        }
                    ]
                },
                {
                    path: `/${ORDERS_ROUTE}`,
                    element: <SecuredRoute />,
                    children: [
                        {
                            path: "",
                            element: <Orders />
                        }
                    ]
                },
                {
                    path: `/${SCREENING_ROUTE}/:imo`,
                    element: <SecuredRoute />,
                    children: [
                        {
                            path: "",
                            element: <Screening />
                        }
                    ]
                },
                {
                    path: "/error/:statusCode",
                    element: <ErrorPage />
                }
            ],
            errorElement: <ErrorPage status={500} /> // Fallback for errors
        }
    ]);
